import React, { useCallback, useEffect, useState, ChangeEvent, KeyboardEvent } from 'react';
import Button from '@ui-library/button';
import { CatchErr } from '@utils/types';
import Input from '@ui-library/input';
import classes from './edit-name.module.scss';

interface OwnProps {
  initialName?: string;
  onClose: () => void;
  onSave: (name: string) => void;
  validateInput: (name: string) => string;
}

const EditName = ({ initialName, onClose, onSave, validateInput }: OwnProps) => {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setName(initialName || '');
  }, []);

  const handleSave = useCallback(async () => {
    try {
      setError('');
      setLoading(true);
      await onSave(name.trim());
      onClose();
    } catch (e: CatchErr) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [onSave, onClose, name, setLoading, setError]);

  const handleOnChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;
      setName(value);
      setError(validateInput(value));
    },
    [setError, setName],
  );

  const handleKeyPress = (event: KeyboardEvent<HTMLElement>) => {
    if (event.key === 'Enter') {
      handleSave();
    }
  };

  return (
    <div className={classes.edit_name_container}>
      <Input
        type="text"
        value={name}
        onChange={handleOnChange}
        placeholder="Enter name"
        maxLength={50}
        onKeyDown={handleKeyPress}
        isError={!!error}
      />
      <Button
        className={classes.confirm_button}
        onClick={handleSave}
        disabled={!name || !!error}
        loading={loading}
        name="Confirm"
      />
      <Button textSecondary className={classes.cancel_button} onClick={onClose} name="Cancel" />
    </div>
  );
};

export default EditName;
